import { useTranslation } from "react-i18next";
import { setLoadingIconTestId } from "./loading-icon.utils";

export function LoadingIcon() {
  const { t } = useTranslation();

  return (
    <div role="status" aria-live="polite" data-testid={setLoadingIconTestId("spinner")}>
      <div aria-hidden="true" className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      <span className="sr-only">{t("common.loading", { defaultValue: "Loading..." })}</span>
    </div>
  );
}
